<template>
  <div class="header__container">
    <div class="cover-overlay" />
    <button class="btn-back" @click="handleGoBack">
      <img
        src="../../../public/img/chevron-left-light.svg"
        style="width: 30px"
      />
    </button>
    <img
      class="header__cover--logo"
      :src="company.foto_perfil_totem"
      :alt="company.nome"
      @error="handleImgError"
    />
    <img v-if="hasValidImg"
      class="header__cover--img"
      :src="company.foto_capa_totem"
      :alt="company.nome"
    />
  </div>
</template>
<script>
import config from "../../config";
import defaultImage from "../../../public/img/icons/hermes-icon-line.png";

export default {
  data() {
    return {
      imgPath: config.URL_IMAGE,
      isLoading: false,
      fallbackImage: defaultImage,
    };
  },
  components: {},
  props: ["company"],
  mounted() {
  },
  computed: {
    hasValidImg() {
      return this.company.foto_capa_totem && this.company.foto_capa_totem.includes("http");
    },
  },
  methods: {
    handleImgError(event) {
      event.target.src = this.fallbackImage;
    },
    handleGoBack(){
      this.$router.go(-1);
    }
  },
};
</script>

<style scoped>
.header__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30%;
  min-height: 200px;
  background-color: #f5f5f5;
  position: relative;
}

.header__cover--img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #2d0f0f8b;
}

.btn-back {
  position: absolute;
  top: 40%;
  left: 3%;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

.cover-icon {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: auto;
  /* z-index: 1; */
}

.header__cover--logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: auto;
  /* z-index: 1; */
}
</style>
